import { Outlet, createFileRoute } from "@tanstack/react-router";

import { ProductLogoMediumContracts as LogoContracts } from "@/components/Logo";
import type { TabWithIndicatorProps } from "@/components/Navigation/HeaderTabs";
import { ProductHeader } from "@/components/ProductHeader";
import { useTranslation } from "@/lib/i18n";

export const Route = createFileRoute("/_staff/contract/_list")({
  component: Layout,
});

function Layout() {
  const { t } = useTranslation();

  const tabs = [
    {
      to: "/contract/overview",
      children: t("common.list.overview"),
      activeOptions: { exact: true },
    },
    {
      to: "/contract",
      children: t("common.list.contracts"),
      activeOptions: { exact: true },
    },
    {
      to: "/contract/people",
      children: t("common.list.people"),
    },
    {
      to: "/contract/alerts",
      children: t("common.list.alerts"),
    },
    {
      to: "/contract/contract-and-cost",
      children: t("common.list.contractAndCost"),
    },
    {
      to: "/contract/operation-activity",
      children: t("common.list.operationActivity"),
    },
  ] satisfies TabWithIndicatorProps[];

  return (
    <div className="flex flex-col">
      <ProductHeader
        Logo={LogoContracts}
        name={t("pages.contract.title")}
        tabs={tabs}
        type="resource"
      />
      <Outlet />
    </div>
  );
}
